import { defineMessages } from 'react-intl';

export default defineMessages({
    certificationYes: {
        id: 'policy.sw.directives.instructor-info.Yes',
        defaultMessage: 'Yes'
    },
    certificationNo: {
        id: 'policy.sw.directives.instructor-info.No',
        defaultMessage: 'No'
    }
});
